export default {
  guardiao_protetor: [
    {
      name: 'Escudo Etéreo',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Escudo Etéreo',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Escudo Etéreo',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Escudo Etéreo',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Escudo Etéreo',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Escudo Sagrado das Runas',
      desc: '1d6 + 1',
      range: 1
    }
  ],

  ninja: [
    {
      name: 'Nunchaku das Runas',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Nunchaku das Runas',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Nunchaku das Runas',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Nunchaku das Runas',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Nunchaku das Runas',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Bastão do Equilíbrio Astral',
      desc: '1d6 + 1',
      range: 2
    }
  ],

  necromante: [
    {
      name: 'Adaga Enferrujada',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Adaga Enferrujada',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Adaga Enferrujada',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Adaga Enferrujada',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Adaga Enferrujada',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Adaga da Traição',
      desc: '1d6 + 1',
      range: 1
    }
  ],

  alquimista: [
    {
      name: 'Arco Médio com Mira',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Arco Médio com Mira',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Arco Médio com Mira',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Arco Médio com Mira',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Arco Médio com Mira',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Braço Canhão "Versão Alfa"',
      desc: '1d6 + 1',
      range: 2
    }
  ],

  monge: [
    {
      name: 'Bastão Iluminado',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Bastão Iluminado',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Bastão Iluminado',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Bastão Iluminado',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Bastão Iluminado',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Luvas das Runas Perdidas',
      desc: '1d6 + 1',
      range: 1
    }
  ],

  ladino: [
    {
      name: 'Adaga das Runas',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Adaga das Runas',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Adaga das Runas',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Adaga das Runas',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Adaga das Runas',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Katar das Trevas',
      desc: '1d6 + 1',
      range: 1
    }
  ],

  bardo: [
    {
      name: 'Besta Leve',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Besta Leve',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Besta Leve',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Besta Leve',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Besta Leve',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Besta de Madeira Branca',
      desc: '1d6 + 1',
      range: 2
    }
  ],

  mestre_modelador: [
    {
      name: 'Bastão de Curto Alcance',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Bastão de Curto Alcance',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Bastão de Curto Alcance',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Bastão de Curto Alcance',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Bastão de Curto Alcance',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Bastão das Eras',
      desc: '1d6 + 1',
      range: 2
    }
  ],

  barbaro: [
    {
      name: 'Besta Leve',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Besta Leve',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Besta Leve',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Besta Leve',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Besta Leve',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Arco de Guerra',
      desc: '1d6 + 1',
      range: 2
    }
  ],

  mercenario: [
    {
      name: 'Espada Longa',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Espada Longa',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Espada Longa',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Espada Longa',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Espada Longa',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Espada Dupla',
      desc: '1d6 + 1',
      range: 1
    }
  ],

  mago: [
    {
      name: 'Adaga Pequena',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Adaga Pequena',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Adaga Pequena',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Adaga Pequena',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Adaga Pequena',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Arco dos Ventos',
      desc: '1d6 + 1',
      range: 2
    }
  ],

  cacador: [
    {
      name: 'Lança de Caça',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Lança de Caça',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Lança de Caça',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Lança de Caça',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Lança de Caça',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Facão de Diamante',
      desc: '1d6 + 1',
      range: 1
    }
  ],

  guerreiro: [
    {
      name: 'Arco Curto',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Arco Curto',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Arco Curto',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Arco Curto',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Arco Curto',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Adaga de Quatro Lâminas',
      desc: '1d6 + 1',
      range: 1
    }
  ],

  arqueiro: [
    {
      name: 'Espada Normal',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Espada Normal',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Espada Normal',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Espada Normal',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Espada Normal',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Espada Larga de Aço Negro',
      desc: '1d6 + 1',
      range: 1
    }
  ],

  clerigo: [
    {
      name: 'Espada Enferrujada',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Espada Enferrujada',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Espada Enferrujada',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Espada Enferrujada',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Espada Enferrujada',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Maça Estrela',
      desc: '1d6 + 1',
      range: 1
    }
  ],

  juiz: [
    {
      name: 'Martelo Normal',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Martelo Normal',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Martelo Normal',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Martelo Normal',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Martelo Normal',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Martelo de Guerra',
      desc: '1d6 + 1',
      range: 1
    }
  ],

  general: [
    {
      name: 'Cajado de Madeira Simples',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Cajado de Madeira Simples',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Cajado de Madeira Simples',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Cajado de Madeira Simples',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Cajado de Madeira Simples',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Bastão Gigante de Pedra',
      desc: '1d6 + 1',
      range: 2
    }
  ],

  assassino: [
    {
      name: 'Espada de Cobre',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Espada de Cobre',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Espada de Cobre',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Espada de Cobre',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Espada de Cobre',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Espada Grande de Prata',
      desc: '1d6 + 1',
      range: 1
    }
  ],

  xama: [
    {
      name: 'Adaga de Ritual',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Adaga de Ritual',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Adaga de Ritual',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Adaga de Ritual',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Adaga de Ritual',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Katar Fantasma',
      desc: '1d6 + 1',
      range: 1
    }
  ],

  mimico: []
}
